import { Module } from 'vuex';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state, ITreuhandEinstellungenState } from './state';

export const NAME = 'treuhandAdministration';
export const store: Module<ITreuhandEinstellungenState, IRootState> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};

export default store;
